/* Samples sheet for board pages on the older template (2 Nov 2026): behaviour as the slatted page's sheet (version 1B,
   assets/al-slatted-pdp.js), for one range drawn by snippets/al-samples-sheet.liquid. Any link marked data-samples-sheet
   opens it; with no dialog support the link stays an ordinary link to the sample product. */
(function () {
  if (window.__alSamplesSheet) return;
  window.__alSamplesSheet = true;
  var dlg = document.getElementById('xs-dlg');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var chips = Array.prototype.slice.call(dlg.querySelectorAll('[data-xs-sample]'));
  var colours = {};
  try { colours = JSON.parse(dlg.getAttribute('data-board-colours') || '{}'); } catch (e) { colours = {}; }
  var busy = false, from = null, timer = 0;

  document.querySelectorAll('a[data-samples-sheet]').forEach(function (a) {
    a.setAttribute('role', 'button');
    a.setAttribute('aria-haspopup', 'dialog');
    a.setAttribute('aria-controls', 'xs-dlg');
  });

  function picked() { return chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }); }
  function plural(n) { return n + (n === 1 ? ' sample' : ' samples'); }
  function setError(msg) {
    var e = document.getElementById('xs-err');
    e.textContent = msg || '';
    e.hidden = !msg;
  }
  function draw() {
    var n = picked().length;
    document.querySelector('#xs-count b').textContent = plural(n);
    document.getElementById('xs-order-t').textContent = busy ? 'Adding…' : 'Order ' + plural(n);
    document.getElementById('xs-order').disabled = !n || busy;
  }

  /* The colour in the buy box now: the theme keeps the chosen variant's ID in the product form */
  function currentColour() {
    var id = new URLSearchParams(window.location.search).get('variant');
    var field = document.querySelector('product-information form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (field && field.value) id = field.value;
    return colours[id] || colours[dlg.getAttribute('data-board-variant')] || '';
  }

  function open(link) {
    if (dlg.open) return;
    clearTimeout(timer);
    from = link;
    busy = false; setError('');
    var colour = currentColour();
    chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-xs-colour') === colour)); });
    draw();
    dlg.showModal();
    document.documentElement.classList.add('xs-lock');
    requestAnimationFrame(function () { dlg.classList.add('is-on'); });
    var title = document.getElementById('xs-title');
    if (title) title.focus({ preventScroll: true });
    var on = dlg.querySelector('.schip[aria-pressed="true"]');
    if (on) on.scrollIntoView({ block: 'nearest', inline: 'center' });
  }
  function close(o) {
    o = o || {};
    if (!dlg.open) return;
    dlg.classList.remove('is-on');
    document.documentElement.classList.remove('xs-lock');
    var done = function () {
      if (!dlg.open || dlg.classList.contains('is-on')) return;
      dlg.close();
      if (from && from.isConnected && o.focus !== false) from.focus({ preventScroll: true });
    };
    if (REDUCED || o.now) done(); else timer = setTimeout(done, 420);
  }

  /* As the slatted page's afterAdd: refresh and open the theme's basket drawer, or go to the basket */
  function afterAdd(json) {
    var page = document.getElementById('PageContainer');
    var cartType = page ? page.getAttribute('data-cart-type') : '';
    var cartAction = page ? page.getAttribute('data-cart-action') : '';
    var bus = window.eventBus, routes = window.routes || {};
    if (bus && cartType === 'drawer') bus.emit('update:cart:drawer', json);
    if (bus && cartType === 'drawer' && cartAction === 'go_to_or_open_cart') {
      bus.emit('open:cart:drawer', { scrollToTop: true });
      bus.emit('cart:added', { sectionId: dlg.getAttribute('data-section') });
      return;
    }
    window.location.href = routes.cart_url || '/cart';
  }
  async function order() {
    var items = picked().map(function (c) { return { id: Number(c.getAttribute('data-xs-sample')), quantity: 1 }; });
    if (busy || !items.length) return;
    busy = true; setError(''); draw();
    var fail = '';
    var json = null;
    try {
      var routes = window.routes || {};
      var res = await fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer' })
      });
      json = await res.json().catch(function () { return null; });
      if (!res.ok) {
        var why = json && (json.description || json.message);
        fail = 'Nothing was added to your basket.' + (why ? ' ' + why : ' Please try again, or call 0161 509 8637.');
      }
    } catch (e) {
      fail = 'We couldn\'t reach the basket. Check your connection and try again, or call 0161 509 8637.';
    }
    busy = false;
    if (fail) {
      setError(fail); draw();
      document.getElementById('xs-order').focus();
      return;
    }
    draw();
    close({ now: true, focus: false });
    afterAdd(json);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-samples-sheet]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open(link);
  });
  document.addEventListener('keydown', function (e) { // role=button: Space works as well as the link's own Enter
    if (e.key !== ' ' || !e.target.matches || !e.target.matches('a[data-samples-sheet]')) return;
    e.preventDefault();
    open(e.target);
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); }); // Escape: the same closing slide as the cross
  dlg.addEventListener('click', function (e) {
    var t = e.target.closest('[data-xs-close], [data-xs-sample], [data-xs-order]');
    if (!t) return;
    if (t.hasAttribute('data-xs-close')) { close(); return; }
    if (t.hasAttribute('data-xs-order')) { order(); return; }
    t.setAttribute('aria-pressed', String(t.getAttribute('aria-pressed') !== 'true'));
    setError(''); draw();
  });
})();
